<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
        viewBox="0 0 32 32"
        version="1.1"
        :class="customClasses"
    >
        <defs></defs>
        <g id="Skisser" stroke="none" stroke-width="1" :fill="hexColor" fill-rule="evenodd" sketch:type="MSPage">
            <g id="0.-Privat,-intresseanmälningar" sketch:type="MSArtboardGroup" transform="translate(-142.000000, -121.000000)" :fill="hexColor">
                <g id="dashboard" :fill="hexColor" sketch:type="MSLayerGroup" transform="translate(142.000000, 121.000000)">
                    <path d="M30,12 L26,12 C24.895,12 24,12.895 24,14 L24,18 C24,19.104875 24.895,20 26,20 L30,20 C31.105,20 32,19.104875 32,18 L32,14 C32,12.895 31.105,12 30,12 Z M26,14 L30,14 L30,18 L26,18 L26,14 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M18,12 L14,12 C12.895,12 12,12.895 12,14 L12,18 C12,19.104875 12.895,20 14,20 L18,20 C19.105,20 20,19.104875 20,18 L20,14 C20,12.895 19.105,12 18,12 Z M14,14 L18,14 L18,18 L14,18 L14,14 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M6,12 L2,12 C0.895,12 0,12.895 0,14 L0,18 C0,19.104875 0.895,20 2,20 L6,20 C7.105,20 8,19.104875 8,18 L8,14 C8,12.895 7.105,12 6,12 Z M2,14 L6,14 L6,18 L2,18 L2,14 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M30,24 L26,24 C24.895,24 24,24.895 24,26 L24,30 C24,31.104875 24.895,32 26,32 L30,32 C31.105,32 32,31.104875 32,30 L32,26 C32,24.895 31.105,24 30,24 Z M26,26 L30,26 L30,30 L26,30 L26,26 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M18,24 L14,24 C12.895,24 12,24.895 12,26 L12,30 C12,31.104875 12.895,32 14,32 L18,32 C19.105,32 20,31.104875 20,30 L20,26 C20,24.895 19.105,24 18,24 Z M14,26 L18,26 L18,30 L14,30 L14,26 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M6,24 L2,24 C0.895,24 0,24.895 0,26 L0,30 C0,31.104875 0.895,32 2,32 L6,32 C7.105,32 8,31.104875 8,30 L8,26 C8,24.895 7.105,24 6,24 Z M2,26 L6,26 L6,30 L2,30 L2,26 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M30,0 L26,0 C24.895,0 24,0.895 24,2 L24,6 C24,7.104875 24.895,8 26,8 L30,8 C31.105,8 32,7.104875 32,6 L32,2 C32,0.895 31.105,0 30,0 Z M26,2 L30,2 L30,6 L26,6 L26,2 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M18,0 L14,0 C12.895,0 12,0.895 12,2 L12,6 C12,7.104875 12.895,8 14,8 L18,8 C19.105,8 20,7.104875 20,6 L20,2 C20,0.895 19.105,0 18,0 Z M14,2 L18,2 L18,6 L14,6 L14,2 Z" id="Path" sketch:type="MSShapeGroup"></path>
                    <path d="M6,0 L2,0 C0.895,0 0,0.895 0,2 L0,6 C0,7.104875 0.895,8 2,8 L6,8 C7.105,8 8,7.104875 8,6 L8,2 C8,0.895 7.105,0 6,0 Z M2,2 L6,2 L6,6 L2,6 L2,2 Z" id="Path" sketch:type="MSShapeGroup"></path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            },
            hexColor: {
                type: String,
                required: false,
                default: '#000000'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
                'icon--large': props.size === 'large'
            })

            return {
                customClasses
            }
        }
    })
</script>
